import React from "react";
import styled from "styled-components";
import { color, font, layout, eyebrow } from "../../theme/tokens";

const Wrap = styled.header`
  display: flex;
  justify-content: center;
  background: ${color.paper};
  padding: 96px 0 56px;

  @media screen and (max-width: 800px) {
    padding: 60px 0 40px;
  }
`;

const Inner = styled.div`
  width: 100%;
  max-width: ${layout.maxWidth};
  padding: 0 ${layout.gutter};

  @media screen and (max-width: 800px) {
    padding: 0 ${layout.gutterMobile};
  }
`;

const Eyebrow = styled.p`
  ${eyebrow}
  margin-bottom: 24px;
`;

const Title = styled.h1`
  font-family: ${font.display};
  color: ${color.green};
  font-size: 64px;
  font-weight: 400;
  letter-spacing: -0.015em;
  line-height: 1.1;
  margin: 0;
  max-width: 16ch;

  @media screen and (max-width: 900px) {
    font-size: 44px;
    max-width: none;
  }

  @media screen and (max-width: 480px) {
    font-size: 34px;
  }
`;

const Lede = styled.p`
  font-family: ${font.body};
  color: ${color.ink};
  font-size: 18px;
  line-height: 1.65;
  max-width: 56ch;
  margin: 28px 0 0;

  @media screen and (max-width: 800px) {
    font-size: 16px;
  }
`;

/** Shared page masthead so /projects and /team share the hero's typography. */
export default function PageHeader({ eyebrow: label, title, lede }) {
  return (
    <Wrap>
      <Inner>
        {label && <Eyebrow>{label}</Eyebrow>}
        <Title>{title}</Title>
        {lede && <Lede>{lede}</Lede>}
      </Inner>
    </Wrap>
  );
}
